/* eslint-disable class-methods-use-this */
import ContractEntity from 'utils/__interfaces/Perimeter/ContractEntity'
import CollapseDto from 'utils/__interfaces/Common/Collapse'

class CollapseTableNormalizer {
  normalize(
    contractList: ContractEntity[],
    organizationId: string
  ): CollapseDto[] {
    const result: CollapseDto = {
      id: `table--${organizationId}`,
      parentId: organizationId,
      type: 'table',
      typeOrganisation: '',
    }

    if (contractList.length === 0) {
      // FIXME organization that has no sub-organization, or sub-insitutions... = what to do with that???
      return [
        {
          ...result,
          data: [
            {
              data1: `organisation "vide", ne contenant ni organisation enfants, ni établissements / contrats enfants...`,
            },
          ],
          dataIds: ['-1'],
          columnNames: ['singleColumn'],
        },
      ]
    }

    return [
      {
        ...result,
        data: contractList.map(
          ({ name: dataName, address, numeroContratSAP }) => ({
            data1: dataName,
            data2: address,
            data3: numeroContratSAP,
          })
        ),
        dataIds: contractList.map(({ id: dataId }) => dataId),
        columnNames: ['name', 'address', 'numéro'],
      },
    ]
  }
}

export default new CollapseTableNormalizer()
